import { isEqual, isNull, isUndefined } from 'lodash';

export default {
  load(value) {
    return value;
  },
  dump(value) {
    return value;
  },
  loadFrom(key) {
    return key;
  },
  dumpTo(key) {
    return key;
  },
  isPresent(value) {
    return !isNull(value) && !isUndefined(value);
  },
  default() {
    return null;
  },
  mapToDefault(value) {
    return isNull(value) ||
      isUndefined(value) ||
      isEqual(this.default(), value);
  },
  loadErrorsFrom(key) {
    return this.dumpTo(key);
  },
  loadErrors(errors) {
    return errors || [];
  },
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/Base.js